import trim from 'lodash/trim';
import upperFirst from 'lodash/upperFirst';
import includes from 'lodash/includes';

interface formatAddressProps {
    city?: string;
    state?: string;
    streetAddress?: string;
    zipcode?: string;
}

export function formatAddress({ city, state, streetAddress, zipcode }: formatAddressProps): string {
    const COMPASS_DIRECTIONS = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];

    const format = (value?: string): string =>
        (value || '')
            .split(' ')
            .map((word) => {
                const casedWord = includes(COMPASS_DIRECTIONS, word)
                    ? word.toUpperCase()
                    : upperFirst(word.toLowerCase());
                return casedWord;
            })
            .join(' ');

    return trim(`${format(streetAddress)}, ${format(city)}, ${state || ''} ${zipcode || ''}`);
}

export const splitAddressLines = (address: string): string[] => [
    address.slice(0, address.indexOf(',')),
    address.slice(address.indexOf(',') + 2),
];
